<div
  class="pt-4"
  [id]="id() | appendTestId: 'time-picker'"
  [attr.data-testid]="id() | appendTestId: 'time-picker'">
  <div
    class="pb-3 font-semibold"
    [id]="id() | appendTestId: 'time-label'"
    [attr.data-testid]="id() | appendTestId: 'time-label'">
    {{ label() }}
  </div>
  <div class="flex flex-row items-center justify-center">
    <div class="w-full">
      <input
        [id]="id() | appendTestId: 'hours'"
        [attr.data-testid]="id() | appendTestId: 'hours'"
        (blur)="setHours($event)"
        (keydown.arrowUp)="increaseHours($event)"
        (keydown.arrowDown)="decreaseHours($event)"
        (keydown.enter)="setHours($event)"
        [formControl]="hours"
        inputmode="numeric"
        class="border-input-ring border-input rounded-input peer p-input w-full bg-transparent placeholder-transparent focus:ring-0"
        type="text" />
    </div>
    <div
      class="px-1"
      [id]="id() | appendTestId: 'separator'"
      [attr.data-testid]="id() | appendTestId: 'separator'">
      :
    </div>
    <div class="w-full">
      <input
        [id]="id() | appendTestId: 'minutes'"
        [attr.data-testid]="id() | appendTestId: 'minutes'"
        (blur)="setMinutes($event)"
        (keydown.arrowUp)="increaseMinutes($event)"
        (keydown.arrowDown)="decreaseMinutes($event)"
        (keydown.enter)="setMinutes($event)"
        [formControl]="minutes"
        inputmode="numeric"
        class="border-input-ring border-input rounded-input peer p-input w-full bg-transparent placeholder-transparent focus:ring-0"
        type="text" />
    </div>
  </div>
</div>
